<input 
  type="text" 
  style="padding: 8px; margin: 15px auto; width: 30%"
  placeholder="Search"
  (keyup)="updateFilter($event)"
/>
<!-- [columns]="columns"  -->
<ngx-datatable #table class="bootstrap vio-table selection-cell" [columnMode]="ColumnMode.force" [headerHeight]="50" [scrollbarH]="true"
[footerHeight]="50" rowHeight="auto" [limit]="10" [rows]="tableData"
(activate)="onActivate($event)"
[rowClass]="getRowClass " (mouseleave)="getMouseLeave()" >


<!-- Column Templates -->
<ng-container *ngFor="let column of tableHeader; let colIndex = index;">
  <ngx-datatable-column [name]="column.label" [prop]="column.key"
   [minWidth]="column.minWidth?column.minWidth:50" 
   [sortable]="column.sortable?column.sortable:false" [draggable]="false"
   >

   <ng-template let-row="row" let-rowIndex="rowIndex" let-col="column" ngx-datatable-cell-template>
    <div class="my-class">
      <strong>{{ row[column.key] }} </strong>
      <div *ngIf="showHideActionDiv(row, row['srno'], colIndex)" class="action-cls">
        <div class="fixedRight">
          <div class="hover-btns-div" >
            <i *ngIf="showHideActionsButtons(row, 'view')" class="fa fa-eye" (click)="vieWClick(row,rowIndex,colIndex)"></i>
            <i *ngIf="showHideActionsButtons(row, 'edit')" class="fa fa-pen" (click)="editClick(row,rowIndex,colIndex)"></i>
            <i *ngIf="showHideActionsButtons(row, 'delete')" class="fa fa-trash" (click)="deleteClick(row,rowIndex,colIndex)"></i>
          </div>
  
        </div>
      </div>
    </div>
 </ng-template>
  </ngx-datatable-column>
</ng-container>


</ngx-datatable>
